<template>
  <v-dialog v-model="internalValue"
            :max-width="maxWidth"
            :persistent="persistent">
    <v-card>
      <v-card-title v-if="title"
                    class="text-h5">
        {{title}}
      </v-card-title>
      <v-card-text>
        <p v-if="message">
          {{message}}
        </p>
        <slot />
        <p v-if="warningMessage"
           :class="warningColor + '--text'">
          {{warningMessage}}
        </p>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text
               :disabled="loading"
               @click="onCancel">
          {{cancelText}}
        </v-btn>
        <v-btn :color="confirmColor"
               text
               :loading="loading"
               @click="onConfirm">
          {{confirmText}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ConfirmDialog',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
    message: {
      type: String,
      default: '',
    },
    warningMessage: {
      type: String,
      default: '',
    },
    warningColor: {
      type: String,
      default: 'warning',
    },
    confirmText: {
      type: String,
      default () {
        return this.$t('yes');
      },
    },
    cancelText: {
      type: String,
      default () {
        return this.$t('cancel');
      },
    },
    confirmColor: {
      type: String,
      default: 'primary',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    maxWidth: {
      type: [String, Number],
      default: 500,
    },
    persistent: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    internalValue: {
      get () {
        return this.value;
      },
      set (value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    onConfirm () {
      this.$emit('confirm');
    },
    onCancel () {
      this.$emit('cancel');
      this.internalValue = false;
    },
  },
};
</script>

<style scoped>

</style>
